import {
	Grid,
	TextField,
	InputLabel,
	Card,
	CardContent,
} from "@material-ui/core";
import React from "react";
import WidgetLanguageDetailModel from "../../../models/RequestForHelpTemplates/WidgetLanguageDetailModel";
import "./../IVRFlowConfiguration/IVRFlowConfiguration.css";
import Shared from "../../../common/shared";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

interface MultiLanguageWidgetProp {
	title: string;
	widgetLanguageDetail: WidgetLanguageDetailModel[];
	selectedLanguageList: string[];
	onMessageDetailChange: (
		widgetLanguageDetail: WidgetLanguageDetailModel
	) => void;
	highlightRequiredDetail?: boolean;
	isValidationRequired?: boolean;
}

export const MultiLanguageWidget: React.FC<MultiLanguageWidgetProp> = ({
	title,
	widgetLanguageDetail,
	selectedLanguageList,
	onMessageDetailChange,
	highlightRequiredDetail,
	isValidationRequired,
}) => {
	const strings = useGetComponentStringsContext().MultiLanguageWidget;

	const onMessageChange = (value: string, item: string) => {
		const updatedInputValue = Shared.getSanitizedInputValue(value);
		const widgetLanguageDetail: WidgetLanguageDetailModel = {
			language: item,
			value: updatedInputValue,
		};
		onMessageDetailChange(widgetLanguageDetail);
	};

	return (
		<Grid item xs={12} className="languageWidgetGrid">
			<InputLabel className="labelHeader">{title}</InputLabel>
			<Card className="errorTextDiv">
				<CardContent>
					{selectedLanguageList &&
						selectedLanguageList.length > 0 &&
						selectedLanguageList.map((language: string, index: number) => (
							<Grid
								item
								xs={12}
								key={index}
								className={index > 0 ? "componentHeader" : ""}
							>
								<TextField
									rows={4}
									multiline
									label={title + strings.languageTitle1 + language}
									value={
										widgetLanguageDetail.find((el) => el.language === language)
											?.value!
									}
									onChange={(event) =>
										onMessageChange(event.target.value, language)
									}
									fullWidth
									required={isValidationRequired ?? false}
									error={
										!widgetLanguageDetail.find((el) => el.language === language)
											?.value! && highlightRequiredDetail
									}
									helperText={
										!widgetLanguageDetail.find((el) => el.language === language)
											?.value! && highlightRequiredDetail
											? `${
													strings.fieldRequiredMessage1 +
													" " +
													title +
													" " +
													strings.fieldRequiredMessage2
											  }`
											: ""
									}
								/>
							</Grid>
						))}
					{selectedLanguageList && !selectedLanguageList.length && (
						<Grid item xs={12}>
							<TextField
								rows={4}
								multiline
								label={title}
								value={widgetLanguageDetail[0]?.value || ""}
								onChange={(event) => onMessageChange(event.target.value, "")}
								fullWidth
								required={isValidationRequired ?? false}
								error={
									!widgetLanguageDetail[0]?.value && highlightRequiredDetail
								}
								helperText={
									!widgetLanguageDetail[0]?.value && highlightRequiredDetail
										? `${
												strings.fieldRequiredMessage1 +
												" " +
												title +
												" " +
												strings.fieldRequiredMessage2
										  }`
										: ""
								}
							/>
						</Grid>
					)}
				</CardContent>
			</Card>
		</Grid>
	);
};
